import { render, staticRenderFns } from "./HeaderCollapsible.vue?vue&type=template&id=4074939a&scoped=true"
import script from "./HeaderCollapsible.vue?vue&type=script&lang=js"
export * from "./HeaderCollapsible.vue?vue&type=script&lang=js"
import style0 from "./HeaderCollapsible.vue?vue&type=style&index=0&id=4074939a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074939a",
  null
  
)

export default component.exports